module.exports = __webpack_public_path__ + "img/beginning@2x.c46622e.webp";